module.exports = __webpack_public_path__ + "static/media/tr.9a7fbecf.svg";